import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { pathnames } from "../config/routes";

import useEmployee from "../features/employees/hooks/useEmployee";
import useEmployees from "../features/employees/hooks/useEmployees";
import useSkills from "../features/skills/hooks/useSkills";


const useRefresher = () => {
  const location = useLocation();
  const [userActive, setUserActive] = useState(true);
  const [refreshCounter, setRefreshCounter] = useState(3);
  const refreshTimerRef = useRef();

  const { employeeId } = useParams();
  useSkills();
  const { refetch: refetchEmployees } = useEmployees();
  const { refetch: refetchEmployee } = useEmployee(employeeId);

  const invalidateData = () => {
    switch (location.pathname) {
      case pathnames.EMPLOYEES: {
        refetchEmployees();
        break;
      }
      default:
        if (employeeId) {
          refetchEmployee();
        }
        break;
    }
  };

  let inactivityTimer;
  const handleMouseMove = () => {
    setUserActive((state) => state || true);
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      setUserActive((state) => (state ? false : state));
    }, 10000);
  };

  const handleWindowBlur = () => {
    setRefreshCounter((state) => Math.max(state - 1, 0));
  };

  const handleWindowFocus = () => {
    setRefreshCounter((state) => (state !== 3 ? 3 : state));
  };

  useEffect(() => {
    clearTimeout(refreshTimerRef.current);
    if (refreshCounter > 0) {
      invalidateData();
      refreshTimerRef.current = setTimeout(() => {
        setRefreshCounter((state) => Math.max(state - 1, 0));
      }, 10000);
    }
    // eslint-disable-next-line
  }, [refreshCounter]);

  useEffect(() => {
    if (userActive) {
      setRefreshCounter((state) => (state !== 3 ? 3 : state));
    } else {
      setRefreshCounter((state) => (state !== 0 ? 0 : state));
    }
    // eslint-disable-next-line
  }, [userActive]);

  useEffect(() => {
    invalidateData();
    setRefreshCounter((state) => (state !== 3 ? 3 : state));
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener("blur", handleWindowBlur);
    window.addEventListener("focus", handleWindowFocus);
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("blur", handleWindowBlur);
      window.removeEventListener("focus", handleWindowFocus);
      window.removeEventListener("mousemove", handleMouseMove);
    };
    // eslint-disable-next-line
  }, []);

  return false;
};

export default useRefresher;
